module.exports = __webpack_public_path__ + "static/media/bg2.ab048aa4.jpg";